import { render, staticRenderFns } from "./BackgroundMaker.vue?vue&type=template&id=0b88d2ac&scoped=true"
import script from "./BackgroundMaker.vue?vue&type=script&lang=js"
export * from "./BackgroundMaker.vue?vue&type=script&lang=js"
import style0 from "./BackgroundMaker.vue?vue&type=style&index=0&id=0b88d2ac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b88d2ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b88d2ac')) {
      api.createRecord('0b88d2ac', component.options)
    } else {
      api.reload('0b88d2ac', component.options)
    }
    module.hot.accept("./BackgroundMaker.vue?vue&type=template&id=0b88d2ac&scoped=true", function () {
      api.rerender('0b88d2ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/BackgroundMaker.vue"
export default component.exports